import React, { useContext, useState, useEffect } from "react";
import './css/shopCategory.css'
import { ShopContext } from "../context/shopContext";
import Item from "../components/items/item";

const ShopCategory = (props) => {
    const { allProducts } = useContext(ShopContext);
    const [displayCount, setDisplayCount] = useState(15); // State to control how many products to display

    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to the top when the product changes
    }, [props.category]);

    const catItems = () => {
        if (props.category === "all") {
            return allProducts
        } else {
            return allProducts.filter(item => item.occasion.includes(props.category))
        }
    }

    const countProducts = () => {
        return catItems().length
    }

    const handleLoadMore = () => {
        setDisplayCount(prevCount => prevCount + 15); // Increase the displayed count by 15
    }

    return (
        <div className="shop-category">
            <img className='shopcategory-banner' src={props.banner} alt="" />
            <div className="shopcategory-indexSort">
                <p>
                    <span>Showing 1-{Math.min(displayCount, countProducts())}</span> out of {countProducts()} products
                </p>
                {/* <div className="shopcategory-sort">
                    Sort by <img src={dropdown_icon} alt="" />
                </div> */}
            </div>
            <div className="shopcategory-products">
                {catItems().slice(0, displayCount).map((item, i) => (
                    <Item key={i} id={item.id} name={item.name} image={item.image} />
                ))}
            </div>
            {displayCount < countProducts() && (
                <div className="shopcategory-loadmore" onClick={handleLoadMore}>
                    Explore More
                </div>
            )}
        </div>
    )
}

export default ShopCategory;
